import { IAppointment } from "../types/appointments.types";

/**
 * The name an appointment carries on the calendar.
 *
 * For a device session that is the machine rather than the technician: what the patient was booked
 * onto is a specific machine in a specific room, while the technician is whoever is on shift and
 * changes between sessions. Everything else keeps showing the therapist.
 */
export function getAppointmentOwnerName(appointment: IAppointment): string {
  const deviceName = appointment.device?.deviceName;
  if (deviceName) return deviceName;
  return appointment.therapistName || "";
}

/**
 * Whether the calendar should treat this as a general event — a note the patient left themselves —
 * rather than a treatment.
 *
 * A treatment is recognised by having someone or something to attend: a therapist, a group, a
 * medium, or the machine it runs on. A device session has only the last of those, which is why the
 * device has to be part of the test; without it the session reads as a note and the board shows a
 * notepad and the word "other" where the machine's name belongs.
 *
 * Lives here, beside the name the card shows, because the rule was copied into nine places and the
 * copies drifted.
 */
export function isOtherEventAppointment(
  appointment: IAppointment,
  isGoogleEvent = false,
): boolean {
  if (appointment.source === "other") return true;
  if (isGoogleEvent) return false;

  return (
    !appointment.therapistsId &&
    !appointment.therapistId &&
    !appointment.treatmentGroupName &&
    !appointment.mediaId &&
    !appointment.device
  );
}
